var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LocationEntity } from './location.entity';
import { MilestoneEntity, } from './milestone.entity';
import { SharingContextEntity, } from './sharing-context.entity';
import { Transform, Type } from 'class-transformer';
import { calcDeltaEta } from '../utils/functions';
var ShipmentEntity = /** @class */ (function () {
    function ShipmentEntity(args) {
        Object.assign(this, args);
    }
    ShipmentEntity.prototype.getCurrentStatus = function () {
        if (this.currentState === 'UNKNOWN')
            return 'PENDING';
        if (/^IN_TRANSIT/.test(this.currentState))
            return 'IN_TRANSIT';
        return this.currentState;
    };
    ShipmentEntity.prototype.getCarrier = function () {
        return this.carrier && this.carrier !== 'UNKNOWN' && this.carrier !== null
            ? this.carrier
            : '-';
    };
    ShipmentEntity.prototype.getDeltaEta = function () {
        return calcDeltaEta(this.deltaPlannedToActualMinutes);
    };
    ShipmentEntity.prototype.getMilestoneByType = function (type) {
        var _a;
        return (_a = this.milestones) === null || _a === void 0 ? void 0 : _a.find(function (milestone) { return (milestone === null || milestone === void 0 ? void 0 : milestone.type) === type; });
    };
    __decorate([
        Type(function () { return LocationEntity; }),
        __metadata("design:type", Object)
    ], ShipmentEntity.prototype, "destinationLocation", void 0);
    __decorate([
        Type(function () { return LocationEntity; }),
        __metadata("design:type", Object)
    ], ShipmentEntity.prototype, "originLocation", void 0);
    __decorate([
        Type(function () { return LocationEntity; }),
        __metadata("design:type", Object)
    ], ShipmentEntity.prototype, "currentStopLocation", void 0);
    __decorate([
        Type(function () { return MilestoneEntity; }),
        __metadata("design:type", Object)
    ], ShipmentEntity.prototype, "milestones", void 0);
    __decorate([
        Type(function () { return SharingContextEntity; }),
        Transform(function (_a) {
            var value = _a.value;
            return ({
                dataOriginators: (value === null || value === void 0 ? void 0 : value.dataOriginators) || [],
                recipients: (value === null || value === void 0 ? void 0 : value.recipients) || [],
            });
        }),
        __metadata("design:type", SharingContextEntity)
    ], ShipmentEntity.prototype, "sharingContext", void 0);
    return ShipmentEntity;
}());
export { ShipmentEntity };
